<template>
	<div class="store w">
		<div class="title" v-text="param.title"></div>
		<div class="store-content clearfloat">
			<div class="store-list clearfloat">
				<div class="store-item" v-for="(item,index) in param.list" :key="index">
					<router-link :to="{path: '/shop', query: {mch_id: item.id}}">
						<div class="store-info clearfloat" :style="{backgroundImage: 'url('+item.back_url+')','backgroundSize': 'cover'}">
							<div class="avatar" :style="{backgroundImage: 'url('+item.pic_url+')'}"></div>
							<div class="store-header">
								<p class="store-title show-one-lines" v-text="item.name"></p>
								<p class="store-description show-one-lines" v-text="item.subtitle"></p>
							</div>
						</div>
					</router-link>
					<div class="store-goods-list clearfloat">
						<router-link :to="{path:'/pages/goods/goods',query:{id:value.goods_id}}" target="_blank" class="store-goods-item" v-for="(value,key) in item.goods_list" :key="key">
							<div class="goods-img"><img class="img-default" :src="value.pic_url" alt=""></div>
							<div class="goods-info">
								<p class="goods-name show-one-lines" v-text="value.name"></p>
								<p class="goods-price" v-text="'￥'+value.price"></p>
							</div>
						</router-link>
					</div>
				</div>
			</div>
			<div class="store-ranking">
				<div class="ranking-title">
					<img class="img-default" src="../../../assets/images/store_title.jpg" alt="">
					<p>本周供应商交易排行</p>
				</div>
				<div class="ranking-list-name">
					<template v-for="(item,index) in param.mch_sort">
						<router-link :to="{path: '/shop', query: {mch_id: item.id}}" class="ranking-item" v-if="index<5">
							<div class="img" v-if="index == 0"><img class="img-default" src="../../../assets/images/store_first.png" alt=""></div>
							<div class="img" v-if="index == 1"><img class="img-default" src="../../../assets/images/store_second.png" alt=""></div>
							<div class="img" v-if="index == 2"><img class="img-default" src="../../../assets/images/store_third.png" alt=""></div>
							<div class="img" v-if="index == 3">4</div>
							<div class="img" v-if="index == 4">5</div>
							<span class="show-one-lines" :title="item.name" v-text="item.name"></span>
						</router-link>
					</template>
				</div>
				<div class="ranking-list-logo clearfloat">
					<template v-for="(item,index) in param.mch_sort">
						<router-link :to="{path: '/shop', query: {mch_id: item.id}}" class="ranking-item" v-if="index>4 && index<13">
							<img class="img-default" :src="item.pic_url" alt="">
							<p class="show-one-lines" :title="item.name" v-text="item.name"></p>
						</router-link>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {
				
			};
		}
	};
</script>

<style lang="scss" scoped>
	.store{
		.title{
			padding: 40px 0 20px 0;
			font-size: 28px;
			font-weight: 600;
			text-align: center;
		}
		.store-list{
			float: left;
			width: 960px;
			.store-item{
				float: left;
				width: 474px;
				height: 290px;
				margin: 0 12px 12px 0;
				background-color: #fff;
				&:nth-child(2n){
					margin-right: 0;
				}
				&:nth-child(3),&:nth-child(4){
					margin-bottom: 0;
				}
				// 商家信息
				.store-info{
					height: 104px;
					padding: 16px;
					box-sizing: border-box;
					cursor: pointer;
					.avatar{
						width: 72px;
						height: 72px;
						border-radius: 50%;
						background-color: #fff;
						float: left;
						background-size: 80%;
						background-repeat: no-repeat;
						background-position: 50%;
						transition: transform .5s ease;
						&:hover{
							transform: scale(1.04);
						}
					}
					.store-header{
						float: left;
						height: 72px;
						padding: 16px 12px;
						max-width: 370px;
						box-sizing: border-box;
						.store-title{
							font-size: 16px;
							color: #333;
							line-height: 16px;
							font-weight: 700;
						}
						.store-description{
							margin-top: 10px;
							font-size: 14px;
							color: #666;
							line-height: 14px;
						}
					}
				}
				// 商品
				.store-goods-list{
					background: #fff;
					.store-goods-item{
						width: 158px;
						height: 186px;
						padding: 20px;
						cursor: pointer;
						float: left;
						text-align: center;
						box-sizing: border-box;
						.goods-img{
							width: 108px;
							height: 108px;
							vertical-align: middle;
							overflow: hidden;
							display: inline-block;
							img{
								transition: transform 0.5s;
							}
							&:hover{
								img{
									transform: scale(1.04);
								}
							}
						}
						.goods-name{
							font-size: 14px;
							color: #333;
							line-height: 22px;
							height: 22px;
							transition: color 0.3s;
						}
						.goods-price{
							font-size: 14px;
							font-weight: 700;
							color: #ff0e25;
						}
						&:hover{
							.goods-name{
								color: #ff0e25;
							}
						}
					}
				}
			}
		}
		.store-ranking{
			width: 222px;
			float: right;
			.ranking-title{
				height: 70px;
				line-height: 70px;
				position: relative;
				text-align: center;
				p{
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					font-size: 18px;
					color: #fff;
					font-weight: 500;
				}
			}
			.ranking-list-name{
				padding: 25px 21px;
				height: 280px;
				box-sizing: border-box;
				background-color: #fff;
				border-bottom: 1px solid #f2f2f2;
				.ranking-item{
					display: block;
					height: 47px;
					line-height: 47px;
					.img{
						height: 28px;
						width: 24px;
						display: inline-block;
						font-size: 16px;
						color: #333;
						text-align: center;
						line-height: 24px;
						font-weight: 500;
						vertical-align: middle;
					}
					span{
						margin-left: 13px;
						font-size: 14px;
						line-height: 14px;
						display: inline-block;
						width: 140px;
					}
				}
				
			}
			.ranking-list-logo{
				height: 242px;
				background-color: #fff;
				padding: 10px 20px;
				box-sizing: border-box;
				.ranking-item{
					width: 91px;
					height: 44px;
					line-height: 44px;
					float: left;
					margin: 5px 0;
					cursor: pointer;
					img{
						margin: 0 auto;
						object-fit: fill;
						width: auto;
					}
					p{
						width: 100%;
						height: 100%;
						background-color: #fafafa;
						text-align: center;
						font-size: 12px;
						padding: 0 5px;
						display: none;
					}
					&:hover{
						img{
							display: none;
						}
						p{
							display: block;
						}
					}
				}
			}
		}
	}
</style>
